/**
 * The pill's control-row classes, named once. The key is the design system's
 * Button (size "sm") wearing PILL_KEY_CLASS on EVERY screen: home's Delegate and
 * the task screen's Delegate, Queue and Stop. One name for both, so the key can
 * never drift into two looks again (it did once, 2026-09-20: staging moved home
 * onto the Button while the task key kept a hand-rolled copy). The marker class
 * leads each string, the className convention this codebase's source pins read.
 *
 * `disabled:pointer-events-auto` beats the Button's own
 * `disabled:pointer-events-none` (cn merges the last one in): a shut key must
 * still take a hover, or its title (why it is shut: the lock's reason, or the
 * file it waits for) never shows. A native disabled button still fires no click.
 * Taking a hover, it would wear base.css's unlayered `button { cursor: pointer
 * !important }`, so `disabled:cursor-not-allowed!` (a layered important, which
 * outranks it) keeps the Button's own shut cursor.
 */
export const PILL_KEY_CLASS =
  "bh-key gap-1.75 px-2.5 disabled:pointer-events-auto disabled:cursor-not-allowed!";

export const PILL_CHIP_CLASS = "bh-chip inline-flex items-center";
